import API_BASE from '../../utils/api';
import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
// Add this import at the top
import ProfileDropdown from "../../components/ProfileDropdown";

// Replace the nav section with this:

const ParentChild = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [childData, setChildData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.studentId) {
      fetchChildDetails();
    } else {
      setLoading(false);
    }
  }, [user]);

  const fetchChildDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE}/students/child/${user.studentId}`,
      );
      setChildData(response.data);
    } catch (error) {
      console.error("Error fetching child details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (loading) {
    return (
      <div className="flex">
        <Sidebar />
        <div className="flex-1 bg-gray-100 flex items-center justify-center h-screen">
          <div className="text-xl">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 bg-gray-100 min-h-screen">
        <nav className="bg-white shadow-sm sticky top-0 z-10">
          <div className="px-6 py-4 flex justify-between items-center">
            <h1 className="text-2xl font-semibold text-gray-800">
              My Child's Profile
            </h1>
            <ProfileDropdown />
          </div>
        </nav>

        <div className="p-6">
          {childData && (
            <div className="space-y-6">
              {/* Profile Header */}
              <div className="bg-white rounded-lg shadow overflow-hidden">
                <div className="px-6 py-8 bg-gradient-to-r from-indigo-500 to-purple-600 text-white">
                  <div className="flex items-center space-x-4">
                    <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center">
                      <span className="text-4xl">👤</span>
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold">{childData.name}</h2>
                      <p className="text-indigo-100">
                        Roll Number: {childData.rollNumber}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h3 className="font-semibold mb-4">
                        Personal Information
                      </h3>
                      <div className="space-y-3">
                        <div>
                          <p className="text-sm text-gray-500">Date of Birth</p>
                          <p className="font-medium">
                            {new Date(
                              childData.dateOfBirth,
                            ).toLocaleDateString()}
                          </p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">Gender</p>
                          <p className="font-medium capitalize">
                            {childData.gender}
                          </p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">Email</p>
                          <p className="font-medium">
                            {childData.email || "Not provided"}
                          </p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">Phone</p>
                          <p className="font-medium">
                            {childData.phone || "Not provided"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="font-semibold mb-4">
                        Academic Information
                      </h3>
                      <div className="space-y-3">
                        <div>
                          <p className="text-sm text-gray-500">Class</p>
                          <p className="font-medium">
                            {childData.classId?.className} -{" "}
                            {childData.classId?.section}
                          </p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">Academic Year</p>
                          <p className="font-medium">
                            {childData.classId?.academicYear || "2024-2025"}
                          </p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">Class Teacher</p>
                          <p className="font-medium">
                            {childData.classId?.classTeacherId?.name ||
                              "Not assigned"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 pt-6 border-t">
                    <h3 className="font-semibold mb-4">Address</h3>
                    <p className="text-gray-700">
                      {childData.address || "No address provided"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Subjects */}
              {childData.classId?.subjects && (
                <div className="bg-white rounded-lg shadow overflow-hidden">
                  <div className="px-6 py-4 bg-green-600 text-white">
                    <h2 className="text-lg font-semibold">Subjects</h2>
                  </div>
                  <div className="p-6">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      {childData.classId.subjects.map((subject, index) => (
                        <div
                          key={index}
                          className="p-3 bg-gray-50 rounded-lg text-center"
                        >
                          <p className="font-medium">{subject.subjectName}</p>
                          {subject.teacherId && (
                            <p className="text-xs text-gray-500 mt-1">
                              {subject.teacherId.name}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParentChild;
